import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const formsApi = createApi({
  reducerPath: 'formsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['Forms', 'PublicForm', 'Submissions'],
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    getProjectForms: builder.query({
      query: ({ projectId }) => ({
        url: `/form/project/${projectId}`,
        method: 'GET',
      }),
      providesTags: (result, error, { projectId }) => [
        { type: 'Forms', id: projectId },
      ],
    }),
    getProjectForm: builder.query({
      query: ({ formId }) => ({
        url: `/form/${formId}`,
        method: 'GET',
      }),
      providesTags: (result, error, { formId }) => [
        { type: 'Forms', id: formId },
      ],
    }),
    getPublicForm: builder.query({
      query: ({ publicFormId }) => ({
        url: `/form/${publicFormId}/public`,
        method: 'GET',
      }),
      providesTags: (result, error, { publicFormId }) => [
        { type: 'PublicForm', id: publicFormId },
      ],
    }),
    getFormSubmissions: builder.query({
      query: ({ formId }) => ({ url: `/form/${formId}/submissions`, method: 'GET' }),
      providesTags: (result, error, { formId }) => [{ type: 'Submissions', id: formId }],
    }),
    getWorkspaceForms: builder.query({
      query: ({ workspaceId }) => ({
        url: `/form/workspace/${workspaceId}`,
        method: 'GET',
      }),
      providesTags: (result, error, { workspaceId }) => [
        { type: 'Forms', id: `workspace-${workspaceId}` },
      ],
    }),
    submitPublicForm: builder.mutation({
      query: ({ formId, data }) => ({
        url: `/form/${formId}/submit`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result, error, { formId }) => [{ type: 'Submissions', id: formId }],
    }),
    createPaymentIntent: builder.mutation({
      query: ({ formId, quantities, email }) => ({
        url: `/form/${formId}/payment-intent`,
        method: 'POST',
        body: { quantities, email },
      }),
    }),
  }),
});

export const {
  useGetProjectFormsQuery,
  useGetProjectFormQuery,
  useGetPublicFormQuery,
  useGetFormSubmissionsQuery,
  useGetWorkspaceFormsQuery,
  useSubmitPublicFormMutation,
  useCreatePaymentIntentMutation,
} = formsApi;
